import { render, staticRenderFns } from "./NoticiasModeradas.vue?vue&type=template&id=04922ca4&scoped=true"
import script from "./NoticiasModeradas.vue?vue&type=script&lang=js"
export * from "./NoticiasModeradas.vue?vue&type=script&lang=js"
import style0 from "./NoticiasModeradas.vue?vue&type=style&index=0&id=04922ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04922ca4",
  null
  
)

export default component.exports